import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { TravelRequestStatus } from '../model/TravelRequestTypes';

interface TravelRequestStatusBadgeProps {
  status: TravelRequestStatus;
}

const statusColor: Record<TravelRequestStatus, string> = {
  DRAFT: 'gray',
  SUBMITTED: 'blue',
  TRAVEL_ORDER_ISSUED: 'violet',
  APPROVED: 'green',
  COMPLETED: 'green.7',
  RETURNED_FOR_CHANGES: 'yellow',
  REJECTED: 'red',
  CANCELLED: 'dark',
};

export function TravelRequestStatusBadge({ status }: TravelRequestStatusBadgeProps) {
  const { t } = useTranslation();

  return <Badge color={statusColor[status]}>{t(`travel.statusEnum.${status}`)}</Badge>;
}
